import { type MouseEvent, type MouseEventHandler, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import type { CreatorModel } from '@domain/models';

import { AuthorInfo } from '../AuthorInfo';

import { CardImage, Content, Overlay, Wrapper } from './styles';

export type ArtworkCardProps = {
	id: string;
	imageSrc: string;
	imageName: string;
	creator: CreatorModel | null;
	onClick?: () => void;
	onAuthorClick?: MouseEventHandler;
};

export const ArtworkCard = (props: ArtworkCardProps) => {
	const theme = useTheme();

	const { id, imageSrc, imageName, creator, onClick, onAuthorClick } = props;

	const handleAuthorClick = useCallback<MouseEventHandler>(
		(event) => {
			// Prevent the card anchor from navigating when the author is clicked.
			event.preventDefault();
			event.stopPropagation();
			onAuthorClick?.(event as MouseEvent);
		},
		[onAuthorClick]
	);

	const altText = `${imageName} jigsaw puzzle${creator?.name ? ` by ${creator.name}` : ''}`;

	return (
		<Wrapper
			component='a'
			href={`/puzzle/${id}`}
			onClick={onClick}
			border={1}
			borderRadius='16px'
			borderColor={theme.colors.border}
		>
			<CardImage src={imageSrc} alt={altText} loading='lazy' decoding='async' width={250} height={250} />
			<Overlay />
			<Content>
				<AuthorInfo
					creator={creator}
					contentTitle={imageName}
					color={theme.colors.cardTextColor}
					onClick={onAuthorClick ? handleAuthorClick : undefined}
				/>
			</Content>
		</Wrapper>
	);
};
